import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-details-page',
  templateUrl: './details-page.component.html',
  styleUrls: ['./details-page.component.css'],
})

export class DetailsPageComponent implements OnInit, OnDestroy {
  
  service!: any;  
  language!: string;
  routeSub!: Subscription;

  constructor(private route: ActivatedRoute,
    private metaTagService:MetaTagService) {}

  ngOnInit(): void {                
    this.language = this.route.snapshot.url[0].path
    
    this.routeSub = this.route.params.subscribe(params => {
      if (params['lang']) {
        this.language = params['lang'];   
        this.getResolverData();         
      }
    });  
    this.getResolverData();    
  }

  getResolverData(){    
    const resolverData = this.route.snapshot.data['article'];            
    if (resolverData) {
      this.service = resolverData.content;
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error("Resolver data is undefined");
    }    
  }

  ngOnDestroy(): void {   
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }

}
